import { Component, EventEmitter, forwardRef, HostBinding, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'wsb-ui-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CheckboxComponent)
    }
  ],
  standalone: false
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() checkboxId: string;
  @Output() checkedChange = new EventEmitter();
  @Input() size: 'normal' | 'small' = 'normal';

  @HostBinding('class.checkbox-custom') hostClass = true;
  @HostBinding('class.is--checked') addCheckedClass = false;

  propagateChange(checked: any) {
    this.checkedChange.emit(checked);
    this.addCheckedClass = !!checked;
  }

  onTouched: any = () => {};

  ngOnInit() {
    this.addCheckedClass = !!this.checked;
  }

  onChange(checked) {
    this.checkedChange.emit(checked);
    this.propagateChange(checked);
  }

  onCheckboxClick(event) {
    event.stopPropagation();
  }

  writeValue(obj: any): void {
    this.checked = obj || false;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
